// extracted by mini-css-extract-plugin
export default {"wrapper":"V2-z","message":"W2-z","image":"X2-z"};